export default __webpack_public_path__ + "static/19-ba9a43becf65aae6b61f952369b44086.jpg";